import { render, staticRenderFns } from "./ChangeProductValue.vue?vue&type=template&id=b2cff9c6&scoped=true&"
import script from "./ChangeProductValue.vue?vue&type=script&lang=ts&"
export * from "./ChangeProductValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cff9c6",
  null
  
)

export default component.exports